<div class="ub ub-ver fw flow-print" :class="{'in-iframe':isIframe}">
  <div class="ub fw ub-ac ub-pc zhezhao detail-load" v-if="editLoading">
    <a-spin :spinning="editLoading" class="ub spin-loading detail-load-spin"></a-spin>
  </div>
  <a-form
    style="min-height: calc(100vh - 181px); background: #fff"
    ref="formRef"
    :layout="'horizontal'"
    :model="formModel"
    :rules="formRules"
    labelAlign="right"
    :scrollToFirstError="scrollOption"
    :label-col="{ style: { width: labelWidth+'px' } }"
    @submit="submitFn"
  >
    <NoviceGuide
      @hidden="hiddenTip"
      :positionClass="positionClass"
      :showButton="false"
      :duration="duration"
      :errorShow="errorShow"
    >
      <template #content>请完善必填项信息哦</template>
    </NoviceGuide>
    <div class="ub ub-ver fw print-div" id="flow-print-table">
      <template v-for="(item,index) in loopSection" :key="index">
        <slot name="header" v-if="item.show&&item.value==='header'">
          <div class="ub ub-ac ub-pb fw bgfff header">
            <div class="ub ub-ac ub-pc title"><slot name="title"> </slot></div>
            <div class="ub ub-ac ub-pc sub-title"><slot name="subTitle"></slot></div>
          </div>
        </slot>
        <print-item
          :class="[index==1?'first-print-item':'',index==loopSection.length-1?'last-print-item':'']"
          v-if="item.show && item.value !=='header' && item.value !== 'qrcode'"
          :item="item"
        >
          <template #header>
            <slot v-if="item.titleSlot" :name="item.titleSlot"></slot>
            <span v-else>{{item.label}}</span>
          </template>
          <template #body>
            <slot :name="item.value">
              <div class="col24">
                <attachment
                  ref="attachRef"
                  v-if="item.value === 'attach'"
                  v-model:value="attachList"
                  :allow-edit="true"
                  :isEdit="isEdit"
                  :biz-type="attachBizType"
                ></attachment>
              </div>
            </slot>
          </template>
        </print-item>
      </template>

      <div class="ub fw" style="background-color: #ffffff" v-if="showFormFooter">
        <div class="interval-footer"></div>

        <div
          class="ub ub-ac ub-pc fw detail-footer"
          :style="{width:isIframe?'calc(100% + 32px)':(collapsed?'calc(100% - 80px)':'calc(100% - 200px)'),left:isIframe?'-16px':(collapsed?'80px':'200px')}"
        >
          <a-space :size="16">
            <slot name="footer">
                <a-button
                  data-type="submit"
                  html-type="submit"
                  type="primary"
                  :disabled="isChange||isEditSave"
                  :loading="editLoading ||loading"
                  v-if="isEdit"
                  >保存</a-button
                >
                <a-button
                  data-type="submit"
                  html-type="submit"
                  type="primary"
                  :disabled="isChange||isEditSave"
                  :loading="createLoading|| loading"
                  v-else
                  >保存</a-button
                >

              <template v-if="examineAccess&&examineAccess!=''">
                <a-button
                  data-type="submitAndAdd"
                  v-perm="examineAccess"
                  html-type="submit"
                  :disabled="loading"
                  type="primary"
                  :loading="editLoading ||loading"
                  >保存并提交</a-button
                >
              </template>

              <a-button @click="cancel">取消</a-button>
              <slot name="footer-external"></slot>
            </slot>
          </a-space>
        </div>
      </div>
    </div>
  </a-form>
  <a-modal
    v-model:visible="bizTypeVisible"
    title="选择流程"
    :confirm-loading="loading"
    :centered="true"
    @ok="handleSubmit"
    :wrapClassName="'biz-modal'"
  >
    <ul class="biz-template">
      <li
        :class="{'active':checkedBizType==item.bizType}"
        v-for="item in bizTypeDatas"
        @click="selectTemplate(item.bizType)"
      >
        {{item.bizTypeName}}
        <check-circle-filled class="icon" />
      </li>
    </ul>
  </a-modal>
</div>
